module.exports = __webpack_public_path__ + "static/media/Generic_Feed-icon.e7340e88.svg";